import { Navigate, Outlet, useLocation } from "react-router-dom";
import { LoadingState } from "../../components/ui";
import type { UserRole } from "../../types/domain";
import { roleHome } from "../../lib/auth-role";
import { useAuth } from "./AuthProvider";

export function ProtectedRoute({ roles }: { roles: UserRole[] }) {
  const { user, loading } = useAuth();
  const location = useLocation();
  if (loading) return <LoadingState label="Verificando sesión" />;
  if (!user) {
    return (
      <Navigate
        to="/ingresar"
        replace
        state={{ from: `${location.pathname}${location.search}${location.hash}` }}
      />
    );
  }
  if (!user.roles.some((role) => roles.includes(role))) {
    return <Navigate to={roleHome(user.role)} replace />;
  }
  return <Outlet />;
}

